import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IAgentLocationFormByIdRouteProps extends PropsWithChildren {
    agentLocationId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const AgentLocationFormByIdRoute: FC<IAgentLocationFormByIdRouteProps> = ({
    agentLocationId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const agentLocationIdToUse = (params.agentLocationId ? +params.agentLocationId : undefined) ?? agentLocationId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={agentLocationIdToUse}
            formDefinitionIdentifier={FormDefinitions.AgentLocation}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default AgentLocationFormByIdRoute;
